/* @flow */

export default class AddLeadNoteRequest {
  isoCompanyId: number;
  companyId: number;
  note: string;
}
